<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {

  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #f0f0f0;
  font-size: 18px;
  min-width: 1200px;
}
.tag {
    padding: 3px 4px;
    font-size: 12px;
    font-weight: 600;
    border-radius: 20px;
    border: solid rgba(0 ,0 ,0 ,0);
    height: 15px;
    line-height: 15px;
}
.normal {
    color: white;
    background: #ff8b3d;
}
.success {
    color: white;
    background: #13ce66;
}
.card {
  padding: 20px 40px;
  border-radius: 15px;
  box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.1);
}


</style>
